module.exports = __webpack_public_path__ + "static/img/slider-33.27df2cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-33.jpg
// module id = 2oZP
// module chunks = 0